import api, { handleAPIErrors } from "shared/api";

const FETCH_REQUEST = "notifications/FETCH_REQUEST";
const FETCH_SUCCESS = "notifications/FETCH_SUCCESS";
const FETCH_FAILURE = "notifications/FETCH_FAILURE";
const UPDATE_REQUEST = "notifications/UPDATE_REQUEST";
const UPDATE_SUCCESS = "notifications/UPDATE_SUCCESS";
const UPDATE_FAILURE = "notifications/UPDATE_FAILURE";
const DELETE_REQUEST = "notifications/DELETE_REQUEST";
const DELETE_SUCCESS = "notifications/DELETE_SUCCESS";
const DELETE_FAILURE = "notifications/DELETE_FAILURE";
const UPDATE_POSITIONS_REQUEST = "notifications/UPDATE_POSITIONS_REQUEST";
const UPDATE_POSITIONS_SUCCESS = "notifications/UPDATE_POSITIONS_SUCCESS";
const UPDATE_POSITIONS_FAILURE = "notifications/UPDATE_POSITIONS_FAILURE";
const RESET_REQUEST = "notifications/RESET_REQUEST";
const RESET_SUCCESS = "notifications/RESET_SUCCESS";
const RESET_FAILURE = "notifications/RESET_FAILURE";

const initialState = {
  result: [],
  loading: false,
  loaded: false,
  updating: false,
  updated: false,
  deleted: false,
  deleting: false,
  positions_updated: false,
  positions_updating: false,
  resetting: false,
  reset: false,
  errors: {},
};

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  };
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  };
}

export function fetchFailure(errors) {
  return {
    type: FETCH_FAILURE,
    errors,
  };
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  };
}

export function updateSuccess(payload) {
  return {
    type: UPDATE_SUCCESS,
    payload,
  };
}

export function updateFailure(errors) {
  return {
    type: UPDATE_FAILURE,
    errors,
  };
}

export function deleteRequest() {
  return {
    type: DELETE_REQUEST,
  };
}

export function deleteSuccess(payload) {
  return {
    type: DELETE_SUCCESS,
    payload,
  };
}

export function deleteFailure(errors) {
  return {
    type: DELETE_FAILURE,
    errors,
  };
}

export function updatePositionsRequest() {
  return {
    type: UPDATE_POSITIONS_REQUEST,
  };
}

export function updatePositionsSuccess(payload) {
  return {
    type: UPDATE_POSITIONS_SUCCESS,
    payload,
  };
}

export function updatePositionsFailure(errors) {
  return {
    type: UPDATE_POSITIONS_FAILURE,
    errors,
  };
}

export function resetRequest() {
  return {
    type: RESET_REQUEST,
  };
}

export function resetSuccess(payload) {
  return {
    type: RESET_SUCCESS,
    payload,
  };
}

export function resetFailure(errors) {
  return {
    type: RESET_FAILURE,
    errors,
  };
}

export function loadNotifications() {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api(`api/v1/notifications`)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(fetchSuccess(json));
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors));
        });
      });
  };
}

export function updateNotification(options = {}) {
  const config = {
    method: "PATCH",
    body: JSON.stringify(options),
  };

  return (dispatch) => {
    dispatch(updateRequest());

    return api(`api/v1/notifications/current`, {}, config)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(updateSuccess(json));
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updateFailure(errors));
        });
      });
  };
}

export function deleteNotification(options = {}) {
  const config = {
    method: "DELETE",
    body: JSON.stringify(options),
  };

  return (dispatch) => {
    dispatch(deleteRequest());

    return api(`api/v1/notifications/current`, {}, config)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(deleteSuccess(json));
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(deleteFailure(errors));
        });
      });
  };
}

export function updatePositions(options = {}, queryParams = "") {
  const config = {
    method: "PUT",
    body: JSON.stringify(options),
  };

  const API_URL = queryParams
    ? `api/v1/notifications/current/update_positions?${queryParams}`
    : `api/v1/notifications/current/update_positions`;
  return (dispatch) => {
    dispatch(updatePositionsRequest());
    return api(API_URL, {}, config)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(updatePositionsSuccess(json));
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(updatePositionsFailure(errors));
        });
      });
  };
}

export function resetNotificationsToDefault() {
  return (dispatch) => {
    dispatch(resetRequest());

    return api(`api/v1/notifications/current`, {}, { method: "DELETE" })
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(resetSuccess(json));
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(resetFailure(errors));
        });
      });
  };
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: payload,
      });
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        result: {
          ...state.result,
        },
        errors: errors,
      };
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true,
      });
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        updated: true,
        errors: [],
        result: payload,
      });
    case UPDATE_FAILURE:
      return {
        ...state,
        errors: errors,
        updating: false,
        updated: true,
        result: [...state.result],
      };
    case DELETE_REQUEST:
      return Object.assign({}, state, {
        deleting: true,
      });
    case DELETE_SUCCESS:
      return Object.assign({}, state, {
        deleting: false,
        deleted: true,
        errors: [],
        result: payload,
      });
    case DELETE_FAILURE:
      return {
        ...state,
        errors: errors,
        deleting: false,
        deleted: true,
        result: [...state.result],
      };
    case UPDATE_POSITIONS_REQUEST:
      return Object.assign({}, state, {
        positions_updating: true,
      });
    case UPDATE_POSITIONS_SUCCESS:
      return Object.assign({}, state, {
        positions_updating: false,
        positions_updated: true,
        errors: [],
        result: payload,
      });
    case UPDATE_POSITIONS_FAILURE:
      return {
        ...state,
        errors: errors,
        positions_updating: false,
        positions_updated: true,
        result: [...state.result],
      };
    case RESET_REQUEST:
      return Object.assign({}, state, {
        resetting: true,
      });
    case RESET_SUCCESS:
      return Object.assign({}, state, {
        resetting: false,
        reset: true,
        errors: [],
        result: payload,
      });
    case RESET_FAILURE:
      return {
        ...state,
        errors: errors,
        resetting: false,
        reset: false,
        result: [...state.result],
      };
    default:
      return state;
  }
}
